import { CACHE_TTL } from '@ps/utils';

/**
 * The company roster behind @mention rarely changes within a session, so it
 * is cached for the session's lifetime. This is only actually true because
 * the state lives in its own `mentionableUsersFeature` slice, which — unlike
 * `ManageSurveyState` — is never reset when the manage-survey page unmounts.
 */
export const MENTIONABLE_USERS_CACHE_TTL_MS = CACHE_TTL.SESSION;
